import { EntityModel } from '@/interfaces'
import {
  ALL_EXTENSIONS_QUERY,
  CREATE_EXTENSION_MUTATION,
  DELETE_EXTENSION_MUTATION,
  FORCE_DELETE_EXTENSION_MUTATION,
  SINGLE_EXTENSION_QUERY,
  UPDATE_EXTENSION_MUTATION,
} from './graphql'
import travelExtensionEntity from '@/entities/travelExtension/entity'
import ratioAccommodationExtensionMapItemEntity from '@/entities/ratioAccommodationExtensionMapItem/entity'

const ratioTravelExtensionModel: EntityModel = {
  name: 'extension',
  namePlural: 'extensions',
  uniqueName: 'ratioTravelExtension',
  uniqueNamePlural: 'ratioTravelExtensions',
  path: 'travel/pricing/adaptors/ratio/extension',
  baseUrl: '/travel/pricing/adaptors/ratio/extensions',
  translationPrefix: 'entities:ratioTravelExtension.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_EXTENSIONS_QUERY,
    getSingle: SINGLE_EXTENSION_QUERY,
    create: CREATE_EXTENSION_MUTATION,
    update: UPDATE_EXTENSION_MUTATION,
    delete: DELETE_EXTENSION_MUTATION,
    forceDelete: FORCE_DELETE_EXTENSION_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:ratioTravelExtension.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioTravelExtension.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    travelExtension: {
      name: 'travelExtension',
      label: 'entities:ratioTravelExtension.attributes.travelExtension.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelExtensionEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    accommodationMapItems: {
      name: 'accommodationMapItems',
      label: 'entities:ratioTravelExtension.attributes.accommodationMapItems.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioAccommodationExtensionMapItemEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioTravelExtensionModel
